import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Inspection, InspectionRestoreItem } from '../../shared/models/index';

@Component({
    selector: 'inspection-restore-list',
    templateUrl: './restore-list.component.html',
    standalone: false
})
export class InspectionRestoreListComponent implements OnInit {
  @Input() public items: InspectionRestoreItem[];
  @Input() public inspection: Inspection;
  @Input() query = '';

  @Output() public toggleSelectItem: EventEmitter<any> = new EventEmitter();

  orderByFieldName = 'name';
  direction = 'asc';
  constructor() {}

  ngOnInit(): void {
    this.initData();
  }

  initData() {}

  public selectItem(e: any, item: any) {
    e.stopPropagation();
    this.toggleSelectItem.emit(item);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
